import BuoyClient from 'lib/BuoyClient';

import { GetJobPostingsAction } from 'state/actions/types/jobPostingsActionsTypes';

export const getJobPostings = (): GetJobPostingsAction => {
  return {
    type: 'GET_JOB_POSTINGS',
    payload: BuoyClient.getJobPostings(),
  };
};
